type SparklineProps = {
  data: number[];
  width?: number;
  height?: number;
  className?: string;
};

export function Sparkline({ data, width = 100, height = 32, className = "" }: SparklineProps) {
  if (data.length === 0) return null;
  const max = Math.max(...data, 1);
  const min = Math.min(...data, 0);
  const range = max - min || 1;
  const dx = data.length > 1 ? width / (data.length - 1) : 0;
  const d = data
    .map(
      (v, i) =>
        `${i === 0 ? "M" : "L"}${(i * dx).toFixed(2)},${(height - ((v - min) / range) * height).toFixed(2)}`,
    )
    .join(" ");
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className={className}>
      <path d={d} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
